module.exports = __webpack_public_path__ + "img/arrow_full_up.75c304c6.svg";